var _path, _path2, _rect, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQMInvCy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "uuid-39a60cd1-cbf6-4996-b1f3-3c22bb64ecc6",
    viewBox: "0 0 90.7 90.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.35,85.7c-22.25,0-40.35-18.1-40.35-40.35S23.1,5,45.35,5s40.35,18.1,40.35,40.35-18.1,40.35-40.35,40.35ZM45.35,9.76c-19.62,0-35.59,15.97-35.59,35.59s15.97,35.59,35.59,35.59,35.59-15.97,35.59-35.59S64.97,9.76,45.35,9.76Z",
    fill: "#ff9a00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.49,44.9h-18.43c-1.37,0-2.33-1.35-1.88-2.64l2.52-7.26c.03-.09.06-.19.08-.28.15-.74,1.43-1.64,1.9-1.7h26.19s0,0,.01,0h1.11c.5.06,1.78.97,1.94,1.7.02.09.04.19.08.28l2.52,7.26c.45,1.29-.51,2.64-1.88,2.64h-14.14Z",
    fill: "#ff9a00"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 42.9,
    y: 13.66,
    width: 4.9,
    height: 28.29,
    rx: 2.45,
    ry: 2.45,
    transform: "translate(17.55 73.15) rotate(-90)",
    fill: "#ff9a00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.48,47.66h4.9v15.23c0,1.35-1.1,2.45-2.45,2.45h0c-1.35,0-2.45-1.1-2.45-2.45v-15.23h0Z",
    fill: "#ff9a00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.32,47.66h22.4v13.51c0,2.3-1.87,4.18-4.18,4.18h-14.05c-2.3,0-4.18-1.87-4.18-4.18v-13.51h0Z",
    fill: "#ff9a00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQMInvCy);
export default __webpack_public_path__ + "static/media/q_M-INV-CY.dd16061b3bcb5706d080c843a98459fe.svg";
export { ForwardRef as ReactComponent };